




































import { Vue, Prop, Component } from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    'label-slot': LabelSlot,
  },
})
export default class SearchByValueComponent extends Vue {
  @Prop({ default: 'Buscar Por...' }) labelBy!: string;

  @Prop({ default: 'Valor...' }) labelValue!: string;

  searchByOptions = [
    {
      value: 'INICIA_COM',
      description: 'Inicia com',
    },
    {
      value: 'CONTEM',
      description: 'Contém',
    },
  ]

  updateField(field: string, value) {
    this.$emit(`update:${field}`, value);
  }

  sendForm() {
    this.$emit('sendForm');
  }
}
